export function hideRememberMePrompt() {
  localStorage.removeItem('MFA:showRememberMePrompt')
  window.history.replaceState(window.history.state, null)
}

export function showRememberPrompt() {
  localStorage.setItem('MFA:showRememberMePrompt', true)
  window.history.replaceState(window.history.state, null)
}
